import React, { useState, useEffect, useContext } from 'react';
import ReactHtmlParser from 'react-html-parser';

import Button from '../../@base/Button';
import Checkbox from '../../@base/Checkbox';
import Datatable from '../../@base/DataTable';
import Input from '../../@base/Input';
import WatsonContext from '../../../context/WatsonContext';
import { Validation } from '../../BotComponents/Commons';
import { validateIntentsAndEntitiesName, showRemoveConfirmation } from '../Commons';
import { IntentDetailAddExampleButton } from './IntentDetailAddExampleButton';

import style from './Intent.module.css';

/** Componente de detalhamento de intenção */
const IntentDetail = (props) => {
  const watsonContext = useContext(WatsonContext);

  const [isValidIntent, setIsValidIntent] = useState(true);
  const [selectedExamplesToDelete, setSelectedExamplesToDelete] = useState([]);
  const [selectedIntent, setSelectedIntent] = useState({
    id: null,
    name: '',
    newName: '',
    description: '',
    examples: [],
  });
  const [example, setExample] = useState({
    id: null,
    text: '',
  });

  /** Volta para visão de lista de intenções */
  const backToListView = () => {
    props.closeIntentDetail();
    if (props.setSelectedIntent) {
      props.setSelectedIntent(selectedIntent.name);
    }
  };

  /** Altera inteção selecionada depois do salvamento no contexto do Watson */
  const postSaveIntent = (e) => {
    setSelectedIntent({
      ...e,
      newName: e.name,
    });
  };

  /** Mostra migalha de pão para detalhamento de intenção */
  const showBreadsrumb = () => {
    const breadsCrumb = selectedIntent.name === ''
      ? 'Nova intenção'
      : `Intenção - ${selectedIntent.name}`;

    return <div className={style.Title}>{breadsCrumb}</div>;
  };

  /** Cria intenção no contexto do Watson se a intenção for valida */
  const createnItent = () => {
    if (isValidIntent) {
      const newIntent = { ...selectedIntent, name: selectedIntent.newName };
      watsonContext.saveIntentOrEntity('intents', newIntent, true, postSaveIntent);
    }
  };

  /** Atualiza intenção no contexto do Watson se a intenção for valida */
  const updateIntent = () => {
    const isCreate = !selectedIntent.id;
    if (isValidIntent && !isCreate) {
      watsonContext.saveIntentOrEntity('intents', selectedIntent, isCreate, postSaveIntent);
    }
  };

  /** Manipulador da ação de validação do nome da intent */
  const setNameInvalidHandler = () => {
    let notAllowedNames = Object.values(watsonContext.intents);
    if (selectedIntent.id) {
      notAllowedNames = notAllowedNames.filter((i) => i.id !== selectedIntent.id);
    }
    notAllowedNames = notAllowedNames.map((i) => i.name);

    const validator = validateIntentsAndEntitiesName(selectedIntent.newName, notAllowedNames);
    return (validator);
  };

  /** Mostra conjutos de campos principais para detalhamento de intenção */
  const showMainFieldSet = () => (
    <>
      <Button small circle classes="float-left" onClick={backToListView}>
        <small><i className="fa fa-angle-left" aria-hidden="true" /></small>
      </Button>
      {showBreadsrumb()}
      <div className="clearfix" />
      <Validation
        isValid={setIsValidIntent}
        setInvalid={setNameInvalidHandler}
      >
        <Input
          label="Nome:"
          small
          classes="mt-2"
          value={selectedIntent.newName}
          mandatory
          onChange={(e) => setSelectedIntent({ ...selectedIntent, newName: e.target.value })}
          onBlur={updateIntent}
        />
      </Validation>
      <Input
        label="Descrição:"
        small
        classes="mt-2"
        value={selectedIntent.description}
        onChange={(e) => setSelectedIntent({ ...selectedIntent, description: e.target.value })}
        onBlur={updateIntent}
      />

      {!selectedIntent.id
        ? (
          <Button
            primary
            small
            classes="mt-2 float-right"
            onClick={createnItent}
            disabled={!isValidIntent}
          >
            <small>Criar intenção</small>
          </Button>
        )
        : null}
    </>
  );

  /** Mostra linhas de exemplos de treinamento */
  const showExamplesTrainning = () => {
    if (selectedIntent.id) {
      const intents = selectedIntent.examples.map((x, i) => {
        let currentExample = x.text;

        let match = /(?<!<a>)@\w+/g.exec(currentExample);
        while (match) {
          const entity = match[0];
          const initIndex = match.index;
          const finalIndex = match.index + match[0].length;
          currentExample = `${currentExample.substring(0, initIndex)}<a>${entity}</a>${currentExample.substring(finalIndex)}`;
          match = /(?<!<a>)@\w+/g.exec(currentExample);
        }

        currentExample = ReactHtmlParser(currentExample);
        return (
          <tr key={x.id}>
            <td><Checkbox id={`example_${i}`} /></td>
            <td data-th="Exemplo">{currentExample}</td>
          </tr>
        );
      });

      return (<tbody>{intents}</tbody>);
    }
    return <></>;
  };

  /** Cria exemplo de treinamento no contexto do watson */
  const saveExample = () => {
    setExample({
      id: null,
      text: '',
    });

    const examplesText = selectedIntent.examples.map((e) => e.text.replace(/\s+/g, ' ').trim());
    if (examplesText.includes(example.text)) return null;

    const intentChanged = {
      ...selectedIntent,
      examples: [example, ...selectedIntent.examples],
    };

    setSelectedIntent(intentChanged);

    if (isValidIntent) {
      watsonContext.saveIntentOrEntity('intents', intentChanged, false, postSaveIntent);
    }
  };

  /** Manipula botão de deletar exemploes de treinamento */
  const deleteExamplesHandler = (examples) => {
    const examplesToDelete = [].concat(examples);
    if (examplesToDelete.length > 0) setSelectedExamplesToDelete(examplesToDelete);
  };

  /** Mostra conjuntos de campos para lista de exemplos de treinamento */
  const showExampleListFieldSet = () => {
    if (!selectedIntent.id) return <></>;

    let className = style.Examples;
    if (selectedIntent.examples.length === 0) className = `${className} ${style.NoExample}`;

    const addButton = (
      <IntentDetailAddExampleButton
        example={example}
        setExample={setExample}
        saveExample={saveExample}
      />
    );

    return (
      <div className={className}>
        <Datatable
          actionsItems={addButton}
          deleteRows={deleteExamplesHandler}
        >
          <table>
            <thead>
              <tr>
                <th scope="col" style={{ width: 60 }}>
                  <Checkbox id="intentexample_check_all" />
                </th>
                <th scope="col">Exemplos de treinamento</th>
              </tr>
            </thead>
            {showExamplesTrainning()}
          </table>
        </Datatable>
      </div>
    );
  };

  /** Remove exemplos de treinamento no contexto do watson */
  const removeExamples = (examplesToDelete) => {
    const changedIntent = {
      ...selectedIntent,
      examples: selectedIntent.examples.filter((e, i) => !examplesToDelete.includes(`example_${i}`)),
    };
    setSelectedIntent(changedIntent);
    const updateObjAfterSave = (e) => { postSaveIntent(e); setSelectedExamplesToDelete([]); };
    if (isValidIntent) {
      watsonContext.saveIntentOrEntity('intents', changedIntent, false, updateObjAfterSave);
    }
  };

  /** Efeito executado na montagem do componente
   *  Carrega estado selectedIntent */
  useEffect(() => {
    if (props.selectedIntent) {
      setSelectedIntent({ ...props.selectedIntent, newName: props.selectedIntent.name });
    }
  }, []);

  return (
    <>
      {showRemoveConfirmation(
        selectedExamplesToDelete,
        removeExamples,
        setSelectedExamplesToDelete,
      )}
      <div className={style.IntentDetail}>
        {showMainFieldSet()}
        <div className="clearfix" />
        {showExampleListFieldSet()}
      </div>
    </>
  );
};

export default IntentDetail;
